import MasterVolume from "./MasterVolume";
import { useState } from "react";
import { FaPause, FaPlay, FaUndo } from "react-icons/fa";

export default function PlaybackControls({ masterVolume, onMasterVolumeChange, hasMix, isPaused, onTogglePause, timer, showTimer = true }) {
  const [minutes, setMinutes] = useState(30);
  const countdown = `${String(Math.floor(timer.remaining / 60)).padStart(2, "0")}:${String(timer.remaining % 60).padStart(2, "0")}`;
  return (
    <section aria-label="Playback controls" className="header-playback">
      <button type="button" disabled={!hasMix} onClick={onTogglePause} className="header-control round-control" aria-label={isPaused ? "Resume mix" : "Pause mix"} title={isPaused ? "Resume mix" : "Pause mix"}>
        {isPaused ? <FaPlay aria-hidden="true" /> : <FaPause aria-hidden="true" />}
      </button>
      <MasterVolume volume={masterVolume} onChange={onMasterVolumeChange} />
      {showTimer && <>
      {timer.isRunning ? (
        <span role="timer" aria-label="Sleep timer remaining" className="timer-display">{countdown}</span>
      ) : (
        <select aria-label="Sleep timer" value={minutes} onChange={(event) => setMinutes(Number(event.target.value))} className="header-control timer-duration" title="Sleep timer duration">
          {[15, 30, 60].map((duration) => <option key={duration} value={duration}>{duration} : 00</option>)}
        </select>
      )}
      <button type="button" disabled={!hasMix && !timer.isRunning} onClick={timer.isRunning ? timer.cancel : () => timer.start(minutes)} className="header-control round-control" aria-label={timer.isRunning ? "Cancel timer" : "Start timer"} title={timer.isRunning ? "Cancel timer" : "Start timer"}>
        {timer.isRunning ? <FaUndo aria-hidden="true" /> : <FaPlay aria-hidden="true" />}
      </button>
      <span className="sr-only" role="status">{timer.finished ? "Timer finished." : ""}</span>
      </>}
    </section>
  );
}
